export default function () {
    var leaves = [];
    this.eachBefore(function (node) {
        if (!node.children) {
            leaves.push(node);
        }
    });
    return leaves;
}
